/**
 * Instant scroll to top — works around mobile Safari / in-app browsers that only update one scroll root.
 */
export function scrollWindowToTop(): void {
  const apply = () => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };
  apply();
  requestAnimationFrame(apply);
}
